import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';

var AbortProvider = /*#__PURE__*/function () {
  function AbortProvider() {
    var _this = this;

    _classCallCheck(this, AbortProvider);

    _defineProperty(this, "_aborted", false);

    _defineProperty(this, "_reason", undefined);

    _defineProperty(this, "_controller", void 0);

    _defineProperty(this, "_callbacks", []);

    _defineProperty(this, "abort", function (reason) {
      var _this$_controller;

      _this._aborted = true;
      _this._reason = reason;
      (_this$_controller = _this._controller) === null || _this$_controller === void 0 ? void 0 : _this$_controller.abort();

      _this._callbacks.forEach(function (c) {
        return c(reason);
      });
    });

    _defineProperty(this, "reset", function () {
      _this._aborted = false;
      _this._reason = undefined;
    });

    _defineProperty(this, "addListener", function (callback) {
      _this._callbacks.push(callback);
    });

    _defineProperty(this, "removeListener", function (callback) {
      _this._callbacks.filter(function (c) {
        return c !== callback;
      });
    });

    if (AbortController === undefined) return;
    this._controller = new AbortController();
  }

  _createClass(AbortProvider, [{
    key: "signal",
    get: function get() {
      var _this$_controller2;

      return (_this$_controller2 = this._controller) === null || _this$_controller2 === void 0 ? void 0 : _this$_controller2.signal;
    }
  }, {
    key: "aborted",
    get: function get() {
      return this._aborted;
    }
  }, {
    key: "reason",
    get: function get() {
      return this._reason;
    }
  }]);

  return AbortProvider;
}();

export { AbortProvider };
